import React, { lazy } from 'react';
import Loadable from 'components/loading/Loadable';
import { ReviewApi } from 'api/community/ReviewApi';
import { ReviewProvider } from './context';
const List = Loadable(lazy(() => import('./list')));
const Create = Loadable(lazy(() => import('./create')));
const Edit = Loadable(lazy(() => import('./edit')));

const ReviewConfig = {
    routes: [
        {
            path: 'review',
            children: [
                {
                    path: '',
                    element: <ReviewProvider><List /></ReviewProvider>
                },
                {
                    path: 'create',
                    element: <ReviewProvider><Create /></ReviewProvider>
                },
                {
                    path: 'modify/:code',
                    element: <ReviewProvider><Edit /></ReviewProvider>
                }
            ]
        }
    ],
    API: ReviewApi
};

export default ReviewConfig;
